import { render, staticRenderFns } from "./rail-bet-row.vue?vue&type=template&id=3e6758f4&scoped=true"
import script from "./rail-bet-row.vue?vue&type=script&lang=js"
export * from "./rail-bet-row.vue?vue&type=script&lang=js"
import style0 from "./rail-bet-row.vue?vue&type=style&index=0&id=3e6758f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6758f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e6758f4')) {
      api.createRecord('3e6758f4', component.options)
    } else {
      api.reload('3e6758f4', component.options)
    }
    module.hot.accept("./rail-bet-row.vue?vue&type=template&id=3e6758f4&scoped=true", function () {
      api.rerender('3e6758f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/rail-bet-row.vue"
export default component.exports